let activeRuntime = null;

export const activateMockTestRuntime = (runtime) => {
  activeRuntime = runtime ? { ...runtime } : null;
};

export const deactivateMockTestRuntime = (moduleId) => {
  if (!moduleId || activeRuntime?.moduleId === moduleId) activeRuntime = null;
};

export const getMockTestRuntime = () => activeRuntime;
